export default __webpack_public_path__ + "static/media/VJA-5.5dc8ab49.webp";